var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex_end w_100"},[_vm._l((_vm.realList),function(item){return [_c('ShipmentProgressStatusBox',{key:item.index,attrs:{"statusTooltip":item.tooltip,"status-code":item.status}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }